module.exports = __webpack_public_path__ + "static/img/user_story_banner_mobile_tr.d2e92814.jpg";